var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAverageTime48Filled = function SvgIconAverageTime48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m34.23 18.17 2.35-2.35-2.4-2.4-2.42 2.42a13.165 13.165 0 0 0-6.05-2.42V11.7h2.3V8.3h-8v3.4h2.3v1.72c-2.24.29-4.31 1.15-6.05 2.42l-2.42-2.42-2.4 2.4 2.35 2.35a13.149 13.149 0 0 0-2.97 8.33c0 7.28 5.92 13.2 13.2 13.2 7.28 0 13.2-5.92 13.2-13.2 0-3.16-1.12-6.05-2.97-8.33h-.02ZM16.8 26h3.4v5h-3.4v-5Zm5.5-5h3.4v10h-3.4V21Zm5.5 3h3.4v7h-3.4v-7Z",
    fill: "current"
  })));
};
export default SvgIconAverageTime48Filled;